import { render, staticRenderFns } from "./dealOrder.vue?vue&type=template&id=0d285e51&"
import script from "./dealOrder.vue?vue&type=script&lang=js&"
export * from "./dealOrder.vue?vue&type=script&lang=js&"
import style0 from "./dealOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports